import React, { useEffect } from "react";
import { Container, Stack } from "@bookingcom/bui-react";
import { ShareFlightButton } from "../../ShareFlight/index.js";
import { FlightDetailsHeaderMobileUI, FlightDetailsTitleMobileUI } from "../../../ui/FlightDetails/index.js";
import { FlightDetailsCampaignBadgeSection } from "./FlightDetailsCampaignBadgeSection.js";
import useCityImage from "../../../../hooks/useCityImage.js";
import { IMAGE_STATIC_ASSETS_URL } from "@flights/constants";
export function FlightDetailsBanner(props) {
    const { backButton, title, campaignBadges, favoriteButton, toIata } = props;
    const [img, setImg] = React.useState(undefined);
    const { getGenericImage } = useCityImage();
    useEffect(() => {
        void getGenericImage(toIata).then((image) => {
            if (image?.generic)
                setImg(IMAGE_STATIC_ASSETS_URL + image.generic.replace("<SIZE>", "600x200"));
        });
    }, [getGenericImage, toIata]);
    return (React.createElement("div", null,
        React.createElement(FlightDetailsHeaderMobileUI, { backButton: backButton, backgroundImageUrl: img, favoriteButton: favoriteButton, shareButton: React.createElement(ShareFlightButton, null) }),
        React.createElement(Container, { attributes: { style: { paddingBlockStart: 0 } } },
            React.createElement(Stack, { gap: 1 },
                React.createElement(FlightDetailsCampaignBadgeSection, { showLoader: true, campaignBadges: campaignBadges }),
                React.createElement(FlightDetailsTitleMobileUI, { text: title })))));
}
